import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'
import * as HIcons from 'react-icons/hi'
import moment from 'moment';
import URLVideoPlayer from './URLVideoplayer';
import Footer from './Footer';
import Slideshow from './Slideshow';
import { collection, query, getDocs, where } from "firebase/firestore";

export default function EventData(props) {

    const params = useParams();

    const [Event, setEvent] = useState({});

    const [isLoaded, setisLoaded] = useState(false);

    const getEvent = async (params) => {
        const q = query(collection(props.db, "events"), where("slug", "==", params));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          setEvent(doc.data());
        });
        setisLoaded(true)
    }


    useEffect(() => {
        getEvent(params.slug);
    }, []);

    return (
        isLoaded ?
        <section>
            {console.log(Event)}
            <div className="pt-16 py-8 bg-cover bg-center md:bg-fixed h-full" style={{ backgroundImage: `linear-gradient(0deg, rgba(16,18,66,0.9) 10%, rgba(16,18,66,0.9) 100%),url(${Event.image})` }}>
                <h1 className='hidden text-center text-[12vw] text-[#ed5955] font-bold lg:text-[8vw] md:flex md:justify-center md:items-center h-96 lg:h-[350px]'>{Event.title}</h1>
                <img src={Event.image} className="w-full rounded-b-2xl md:hidden" alt={Event.title} />
                <section className='px-8'>
                    <h1 className='text-center text-[10vw] py-8 font-bold text-[#ed5955] lg:text-[8vw] md:hidden'>{Event.title}</h1>
                    <div className='flex flex-col'>
                        <div className='flex space-x-4 items-center'>
                            <HIcons.HiOutlineClock className='text-[4vw] lg:text-[2vw] text-[#F4DC7C]' />
                            <p className='text-[4vw] lg:text-[2vw]'>{moment
                                    .unix(Event.eventdate.seconds)
                                    .format("MMMM Do YYYY - hh:mm a")}
                                </p>
                        </div>
                        <div className='flex space-x-4 items-center'>
                            <HIcons.HiLocationMarker className='text-[4vw] lg:text-[2vw] text-[#F4DC7C]' />
                            <p className='text-[4vw] lg:text-[2vw]'>{Event.location}</p>
                        </div>
                    </div>
                    <div className='bg-[#F4DC7C] h-[1px] w-full my-4'></div>
                    <h1 className='text-[8vw] font-bold text-[#ed5955] lg:text-[4vw]'>About Event</h1>
                    <article className='text-[5vw] lg:text-[2.5vw]'>
                        {Event.description}
                    </article>
                    <div className={Event.slideshow ? 'block' : 'hidden'}>
                        <div className='bg-[#F4DC7C] h-[1px] w-full my-4'></div>
                        <h1 className='text-[8vw] font-bold text-[#ed5955] lg:text-[4vw]'>Event Photos</h1>
                        <Slideshow image={Event.slideshow} />
                    </div>
                    <div className={Event.video ? 'block' : 'hidden'}>
                        <div className='bg-[#F4DC7C] h-[1px] w-full my-4'></div>
                        <h1 className='text-[8vw] font-bold text-[#ed5955] lg:text-[4vw] mb-8'>Event Video</h1>
                        <URLVideoPlayer
                            video={Event.video}
                        />
                    </div>
                </section>
            </div>
            <Footer />
        </section> : <div className='flex items-center justify-center h-screen'>
            <span className="loader"></span>
        </div>
    );
}